<template>
  <input class="input-file" :id="id" type="file" :accept="accept" @change="change" />
</template>

<script setup>
const props = defineProps(['id', 'accept', 'modelValue']);
const emits = defineEmits(['update:modelValue']);
const file = (event) => event.target.files[0] ?? '';
const change = (event) => emits('update:modelValue', file(event));
</script>

<style scoped>
input[type=file]::-webkit-file-upload-button,
input[type=file]::file-selector-button
{
  @apply py-2.5 pl-8 pr-4;
  @apply font-medium text-gray-500 text-sm;
  @apply bg-gray-50 hover:bg-gray-600;
  @apply border-0 border-r border-gray-300;
  @apply cursor-pointer;

  margin-inline-start: -1rem;
  margin-inline-end: 1rem;
};

.input-file
{
  @apply block w-full;
  @apply text-sm text-gray-900;
  @apply bg-white rounded-lg;
  @apply border border-gray-300;
  @apply cursor-pointer;
  @apply focus:outline-none;
};
</style>
